import initialState from './initialState'
import * as types from '../actions/actionTypes'

export default function snackbarReducer(state = initialState.snackbarState, action: any) {
  switch (action.type) {
    case types.SET_FEEDBACK_MESSAGE: {
      return {
        ...state,
        feedbackMessage: action.payload
      }
    }
    case types.SET_FEEDBACK_MESSAGE_VARIANT: {
      return {
        ...state,
        feedbackMessageVariant: action.payload
      }
    }
    case types.OPEN_FEEDBACK_MESSAGE: {
      return {
        ...state,
        openFeedbackMessage: true
      }
    }
    case types.CLOSE_FEEDBACK_MESSAGE: {
      return {
        ...state,
        openFeedbackMessage: false
      }
    }
    default: return state
  }

}


// WEBPACK FOOTER //
// ./src/modules/core/reducers/snackbarReducer.tsx